import React from "react"
import CenterHeader from "../components/CenterHeader"
import ImageTextRowTwo from "../components/ImageTextRowTwo"
import backup from "../images/backup.png"
// import backup2 from "../images/backup2.jpg"
import presidentImage from "../images/president.jpg"
import dsp_seal from "../images/dsp_seal.png"
import { VideoCoverLayout } from "../components/Layout"
import { Helmet } from "react-helmet"
import video from "../images/index.mp4"
// import video from "../images/fall2024_vid.mp4"
import ImageBox from "../components/ImageBox"
import Button from "../components/TransparentButton"
import { Fade } from "react-reveal"
import styles from "./home.module.css"

import careerAdvantage from "../images/dsp2025panel.jpeg"
import lifelongBrotherhood from "../images/lifelongBrotherhood.jpg"
import brothers from "../images/brothers.jpg"
import unrivaledLeaders from "../images/presidents.jpg"

export default () => (
  <VideoCoverLayout
    video={video}
    image={backup}
    navbarTextColor="white"
    textOne="Delta Sigma Pi"
    textTwo="The Premier Business Fraternity | Pi Sigma Chapter"
    coverImage={dsp_seal}
  >
    <div className={styles.homePage}>
      <div className={styles.homePageFade}>
    <Helmet>
      <title>Delta Sigma Pi - Pi Sigma Chapter</title>
      <meta
        name="Delta Sigma Pi - Pi Sigma Chapter Home Page"
        content="Delta Sigma Pi - Pi Sigma Chapter Home Page"
      />
    </Helmet>
    <hr style={{
          border: 0,
          height: '1px',
          background: '#666',
          margin: '40px auto 30px',
          width: '100%'
        }} />
    <Fade bottom distance="0px" duration={700}>
      <div className={styles.cardsRow}>
        <ImageBox
          image={unrivaledLeaders}
          title="ABOUT US"
          actions={<Button to="/about" text="WHO WE ARE" />}
          equalHeight
        >
          Established in 2008, the Pi Sigma Chapter of Delta Sigma Pi at UC
          Irvine is the oldest business fraternity on campus. Our chapter has
          cultivated a growing legacy of achievement, mentorship, and leadership
          within business and beyond.
        </ImageBox>
        <ImageBox
          image={brothers}
          title="BROTHERS"
          actions={<Button to="/brothers" text="MEET OUR BROTHERS" />}
          equalHeight
        >
          From various professional aspirations to pastime hobbies, our brothers
          are incredibly unique and diverse. Our drive to succeed and support
          for one another makes us a tight-knit community like no other.
        </ImageBox>
        <ImageBox
          image={careerAdvantage}
          title="CAREERS"
          actions={<Button to="/careers" text="OUR EXPERIENCE" />}
          equalHeight
        >
          We have countless brothers with competitive internships and full-time
          experience in finance, marketing, technology, accounting, consulting,
          entrepreneurship, and more – the opportunities for growth are endless
          with Delta Sigma Pi.
        </ImageBox>
      </div>
    </Fade>
    <hr style={{
          border: 0,
          height: '1px',
          background: '#666',
          margin: '48px auto',
          width: '80%'
        }} />
    <Fade bottom distance="0px" duration={700}>
      <CenterHeader>Letter from the President</CenterHeader>
      <ImageTextRowTwo imagePosition="left" imageSrc={presidentImage}>
        {/* Dear Prospective Member,
        <br /> */}
        {/* <br /> */}
        Dear Prospective Member,
        <br />
        <br />
        When I first came out to DSP recruitment, what stood out to me was the people. I met brothers who were incredibly driven and ambitious, but at the same time, people I could genuinely see myself becoming close friends with. Coming into college, I knew I wanted to surround myself with people who would push me to work harder, aim higher, and make the most of my time here. DSP felt like exactly that environment.
        <br />
        <br />
        What I didn’t realize then was how important those people would become to me. DSP has become one of the biggest constants in my college experience, and my class and the brothers I’ve met have truly become my rock. They’re the people I see nearly every day, celebrate my wins with, turn to when things get difficult, travel with, and make some of my favorite memories with. I joined because I wanted to be surrounded by ambitious people, but I stayed because those people became some of my closest friends.
        <br />
        <br />
        That balance is what makes DSP so special to me. Everyone here wants to accomplish something and pushes the people around them to be better, but our relationships extend far beyond academics, internships, or careers. The conversations, laughs, late nights, trips, and random moments together are just as much a part of DSP as the professional side. I’m incredibly proud to be a part of this chapter and of the community we’ve built.
        <br />
        <br />
        Recruitment is as much an opportunity for you to evaluate us as it is for us to meet you. Come out, talk to our brothers, and get to know them beyond their resumes. Think about whether these are people who inspire you, but also people you could see becoming some of your closest friends. The people you surround yourself with in college will shape your experience more than you realize.
        <br />
        <br />
        As President of the Pi Sigma Chapter, I’m excited to meet the people who could become the next part of our brotherhood. DSP has given me some of the most important people in my college experience, and I’m excited to find more people who can add to the community that has meant so much to me.
        <br />
        <br />
        Warm regards,
        <br />

        Shreya Jagannathan | President - Pi Sigma Chapter
      </ImageTextRowTwo>
    </Fade>
      </div>
    </div>
  </VideoCoverLayout>
)